module.exports = __webpack_public_path__ + "img/Classic_car.4565f84.jpeg";